import { STORAGE_AUTH_TOKEN } from 'constants/store';

/* eslint-disable import/prefer-default-export */
export const getTokenFromStorage = () => JSON.parse(localStorage.getItem(STORAGE_AUTH_TOKEN));
